import { getClientRuntimeConfig } from '@/config/runtime/clientRuntimeConfig';
import BrowserStorage from '@/services/BrowserStorage';

const NAMESPACE = 'bcache';

/*
    A Utility for saving data on the client browser for the current session,
    in a way that makes it easy to clean up.
    If this code is called on the server it will be a no-op.
 */
class SessionStorage extends BrowserStorage {
    private static instance: SessionStorage;
    public static getInstance(): SessionStorage {
        if (!SessionStorage.instance) {
            SessionStorage.instance = new SessionStorage(
                typeof window !== 'undefined' ? window.sessionStorage : undefined,
                `${NAMESPACE}-${getClientRuntimeConfig().buildId}`
            );
        }
        return SessionStorage.instance;
    }

    public set(key: string | string[], data: any): boolean {
        return this.save(key, data);
    }

    public get<T = any>(key: string | string[]): T | undefined {
        return this.retrieve<T>(key);
    }
}

export default SessionStorage.getInstance();
